// extracted by mini-css-extract-plugin
export default {"pointsResults":"pointsResults___fb4f4a12f566287f","pointsLabel":"pointsLabel___d492b4e39eff3f2d"};